var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ProjectType, StudyDto } from "healthex-common/study.dtos";
import { willNeverHappen } from "healthex-common/utils";
import { computed, observable } from "mobx";
import { resourceScopeDescription, sensitivityScopeDescription } from "./DataScopeDescriptions";
import { ConsentDataSensitivityScope } from "healthex-common/consentscopes.dtos";
export class HXProjectDetailsViewModelProps {
    constructor(study, container) {
        this.study = study;
        this.container = container;
    }
}
export class HXProjectDetailsViewModel {
    constructor(props) {
        const { study } = props;
        this.study = study;
    }
    get shouldUseStudyDetailsInstead() {
        return !this.study.pdda;
    }
    get projectTypeDescription() {
        switch (this.study.projectType) {
            case ProjectType.GENERAL_DATA_USE:
                return "Patient Health Record Access";
        }
        return willNeverHappen(this.study.projectType);
    }
    get typesOfDataDescriptions() {
        return [
            ...this.study.consentDataResourceScopes.map((scope) => resourceScopeDescription(scope)),
            ...this.study.consentDataSensitivityScopes
                .filter((scope) => scope !== ConsentDataSensitivityScope.NORMAL)
                .map((scope) => sensitivityScopeDescription(scope)),
        ];
    }
    get typesOfDataDescriptionsColumns() {
        return [
            this.typesOfDataDescriptions.slice(0, Math.ceil(this.typesOfDataDescriptions.length / 2)),
            this.typesOfDataDescriptions.slice(Math.ceil(this.typesOfDataDescriptions.length / 2)),
        ];
    }
}
__decorate([
    observable,
    __metadata("design:type", StudyDto)
], HXProjectDetailsViewModel.prototype, "study", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HXProjectDetailsViewModel.prototype, "shouldUseStudyDetailsInstead", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HXProjectDetailsViewModel.prototype, "projectTypeDescription", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HXProjectDetailsViewModel.prototype, "typesOfDataDescriptions", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HXProjectDetailsViewModel.prototype, "typesOfDataDescriptionsColumns", null);
